export default "__VITE_ASSET__BuyVWGeH__"